module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="' +
((__t = ( styles.login )) == null ? '' : __t) +
'">\n  <div class="' +
((__t = ( styles.socialLogin )) == null ? '' : __t) +
'">\n    ' +
((__t = ( heading({ heading: 'Sign in with:' }) )) == null ? '' : __t) +
'\n    ' +
((__t = ( socialButton({ type: 'facebook' }) )) == null ? '' : __t) +
'\n    ' +
((__t = ( socialButton({ type: 'twitter' }) )) == null ? '' : __t) +
'\n    ' +
((__t = ( socialButton({ type: 'instagram' }) )) == null ? '' : __t) +
'\n  </div>\n  <div class="' +
((__t = ( styles.siteLogin )) == null ? '' : __t) +
'">\n    <form>\n      ' +
((__t = ( heading({ heading: 'Or, here:' }) )) == null ? '' : __t) +
'\n      <fieldset>\n        ' +
((__t = ( input({ label: 'Email or username', name: 'principal', type: 'text', required: true }) )) == null ? '' : __t) +
'\n        ' +
((__t = ( input({ label: 'Password', name: 'credential', type: 'password', required: true }) )) == null ? '' : __t) +
'\n        ' +
((__t = ( input({ name: 'identityType', type: 'hidden', value: '_INTERNAL' }) )) == null ? '' : __t) +
'\n      </fieldset>\n      <div class="' +
((__t = ( styles.submitRow )) == null ? '' : __t) +
'">\n        ' +
((__t = ( validation({ name: '*' }) )) == null ? '' : __t) +
'\n        ' +
((__t = ( validation({ name: 'username' }) )) == null ? '' : __t) +
'\n        ' +
((__t = ( validation({ name: 'emailAddress' }) )) == null ? '' : __t) +
'\n        ' +
((__t = ( submitButton({ label: 'Sign in' }) )) == null ? '' : __t) +
'\n      </div>\n      <ul class="' +
((__t = ( styles.screenLinks )) == null ? '' : __t) +
'">\n        <li>' +
((__t = ( screenLink({ screen: 'forgotPassword' }) )) == null ? '' : __t) +
'</li>\n        <li>' +
((__t = ( screenLink({ screen: 'register', label: 'Register' }) )) == null ? '' : __t) +
'</li>\n      </ul>\n    </form>\n  </div>\n</div>\n';

}
return __p
}